import { useDFR } from '../context/DFRContext';
import { getPropStatus, fetchPropertyData, getProp, fetchDFREntries } from "../../../api/services/property";

export const usePropertyFetcher = () => {
    const DFRContext = useDFR();

    const checkPropStatus = async (setOneProp, p) => {
        const resp = await getPropStatus(p.ref)
        const status = resp.data
    
        if(status == 'broken' || status == 'data') {
            p.status = status
            setOneProp(p)
            if(status == 'data') {
                fetchPropData(setOneProp, p)
            }
        } else {
            setTimeout(() => {
                checkPropStatus(setOneProp, p); 
            }, 2000);
        }
    }

    const fetchPropData = async (setOneProp, p) => {
        p.fetch = true
        await setOneProp(p)
    
        const resp = await fetchPropertyData(p.ref, p.type)
        const data = resp.data
    
        data && typeof data == 'object' ? p.data = data : p.status = 'warning'
    
        if(data) {
            if(p.type == 'PROP') {               
                const getPropResp = await getProp(p.ref)
                const propData = getPropResp.data
    
                if(propData) {
                    if(propData.geojson) {
                        p.border = propData.geojson.geometry.coordinates
                    }
                    if(propData.area) {
                        p.area = propData.area
                    }
                }
            }
            
            if('data' in p) {
                let volume = 0
                data.sections.map(s => volume += s.volume)
                p.volume = volume
            }
    
            if(p.dfr) {   
                DFRContext.getWind(p.ref, p.data.centroid, 'month')
                DFRContext.getWind(p.ref, p.data.centroid, 'years')
                DFRContext.getWindEdgeRisk(p.ref)
                DFRContext.getWeatherData(p.ref, p.designation)
    
                const entriesResponse = await fetchDFREntries(p.ref, p.type)
    
                let entryData = entriesResponse.data
                entryData.entries.forEach(entry => {entry.ref = p.ref; entry.designation = p.designation})
                await DFRContext.setEntries(prevEntries => prevEntries.concat(entryData.entries))
            }
        }
        
        p.fetch = false
        p.ready = true
        await setOneProp(p)
    }
    
    return { checkPropStatus, fetchPropData }
}